<template>
  <header class="header">
    <div class="container">
      <nav class="navbar">
        <!-- Logo -->
        <div class="logo">
          <router-link :to="localizedPath('home')">
            <img src="https://auto-moto-sales.web.app/images/auto-moto-sales-logo.webp" :alt="$t('companyLogo')" />
          </router-link>
        </div>

        <!-- Mobile Menu Button -->
        <div class="mobile-menu-button" @click.stop="toggleMobileMenu">
          <span class="burger-icon">&#9776;</span>
        </div>

        <!-- Navigation Menu -->
        <div class="nav-menu-div" :class="isMobileMenuOpen ? 'mobile-menu-open' : ''">
          <ul class="nav-menu">
            <li>
              <router-link :to="localizedPath('home')" active-class="active-link">
                {{ $t('navbar.routes.home') }}
              </router-link>
            </li>
            <li>
              <router-link :to="localizedPath('contact')" active-class="active-link">
                {{ $t('navbar.routes.contact') }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Language Dropdown -->
        <div class="language-dropdown" ref="dropdown">
          <button class="dropdown-btn" ref="dropdownBtn" @click.stop="toggleDropdown">
            {{ $t(`navbar.language.${currentLanguage}`) }}
          </button>
          <div v-show="isDropdownOpen" class="dropdown-content">
            <div v-if="currentLanguage !== 'german'" class="dropdown-item">
              <a href="#" @click.prevent="changeLanguage('de')">
                {{ $t('navbar.language.german') }}
              </a>
            </div>
            <div v-if="currentLanguage !== 'french'" class="dropdown-item">
              <a href="#" @click.prevent="changeLanguage('fr')">
                {{ $t('navbar.language.french') }}
              </a>
            </div>
            <div v-if="currentLanguage !== 'english'" class="dropdown-item">
              <a href="#" @click.prevent="changeLanguage('en')">
                {{ $t('navbar.language.english') }}
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>


export default {
  inject: ['$route'],
  data() {
    return {
      isDropdownOpen: false,
      isMobileMenuOpen: false,
      currentLanguage: 'german', // Default language set to German
      languages: {
        de: 'german',
        fr: 'french',
        en: 'english',
      },
    };
  },
  computed: {
    // ✅ Use computed properties to access the global `$localizedPath()`
    localizedPath() {
      return (routeKey) => {
        return this.$localizedPath(routeKey);
      };
    },
    // ✅ Computed property to always get the current route name
    currentRouteName() {
      return this.$route?.name || null; // If route is undefined, return null
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    changeLanguage(lang) {
      this.currentLanguage = this.languages[lang];
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang);
      sessionStorage.setItem('locale', lang);

      console.log(`Language changed to: ${this.$t(`navbar.language.${this.currentLanguage}`)}`);
      this.isDropdownOpen = false;

      // ✅ Get the current route name
      const currentRouteName = this.currentRouteName;
      console.log(currentRouteName);

      if (currentRouteName) {
        // ✅ Redirect to the same page but in the new language
        const newPath = this.$localizedPath(currentRouteName);
        console.log(`🔄 Redirecting to: ${newPath}`);
        console.log(currentRouteName);
        this.$router.push(newPath);
      } else {
        // ✅ Fallback to home if no current route name is found
        const homePath = this.$localizedPath('home');
        console.log(`🏠 Redirecting to home: ${homePath}`);
        this.$router.push(homePath);
      }
    }
    ,

    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
  }
};
</script>

<style scoped></style>
